// sign in
export const SIGN_IN_REQUEST = 'auth/SIGN_IN_REQUEST';
export const SIGN_IN_SUCCESS = 'auth/SIGN_IN_SUCCESS';
export const SIGN_IN_FAILURE = 'auth/SIGN_IN_FAILURE';

// sign up
export const SIGN_UP_REQUEST = 'auth/SIGN_UP_REQUEST';
export const SIGN_UP_SUCCESS = 'auth/SIGN_UP_SUCCESS';
export const SIGN_UP_FAILURE = 'auth/SIGN_UP_FAILURE';

// sign out
export const SIGN_OUT_REQUEST = 'auth/SIGN_OUT_REQUEST';
export const SIGN_OUT_SUCCESS = 'auth/SIGN_OUT_SUCCESS';
export const SIGN_OUT_FAILURE = 'auth/SIGN_OUT_FAILURE';

// set is authenticated
export const SET_IS_AUTHENTICATED = 'auth/SET_IS_AUTHENTICATED';

// set token
export const SET_TOKEN = 'auth/SET_TOKEN';

// verifyEmail
export const VERIFY_EMAIL_REQUEST = 'auth/VERIFY_EMAIL_REQUEST';
export const VERIFY_EMAIL_SUCCESS = 'auth/VERIFY_EMAIL_SUCCESS';
export const VERIFY_EMAIL_FAILURE = 'auth/VERIFY_EMAIL_FAILURE';

// set emailVerified
export const SET_EMAIL_VERIFIED = 'auth/SET_EMAIL_VERIFIED';

// set email
export const SET_EMAIL = 'auth/SET_EMAIL';

// send reset password link
export const RESET_PASSWORD_LINK_REQUEST = 'auth/RESET_PASSWORD_LINK_REQUEST';
export const RESET_PASSWORD_LINK_SUCCESS = 'auth/RESET_PASSWORD_LINK_SUCCESS';
export const RESET_PASSWORD_LINK_FAILURE = 'auth/RESET_PASSWORD_LINK_FAILURE';

// verify password reset code
export const VERIFY_PASSWORD_OOBCODE_REQUEST =
  'auth/VERIFY_PASSWORD_OOBCODE_REQUEST';
export const VERIFY_PASSWORD_OOBCODE_SUCCESS =
  'auth/VERIFY_PASSWORD_OOBCODE_SUCCESS';
export const VERIFY_PASSWORD_OOBCODE_FAILURE =
  'auth/VERIFY_PASSWORD_OOBCODE_FAILURE';

// reset password
export const RESET_PASSWORD_REQUEST = 'auth/RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'auth/RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'auth/RESET_PASSWORD_FAILURE';

// recover email
export const RECOVER_EMAIL_REQUEST = 'auth/RECOVER_EMAIL_REQUEST';
export const RECOVER_EMAIL_SUCCESS = 'auth/RECOVER_EMAIL_SUCCESS';
export const RECOVER_EMAIL_FAILURE = 'auth/RECOVER_EMAIL_FAILURE';

// dismiss request
export const DISMISS_AUTH_REQUEST = 'auth/DISMISS_AUTH_REQUEST';

// register to mail magazine
export const RETRY_TO_MAIL_MAGAZINE_REQUEST =
  'auth/RETRY_TO_MAIL_MAGAZINE_REQUEST';
export const RETRY_TO_MAIL_MAGAZINE_SUCCESS =
  'auth/RETRY_TO_MAIL_MAGAZINE_SUCCESS';
export const RETRY_TO_MAIL_MAGAZINE_FAILURE =
  'auth/RETRY_TO_MAIL_MAGAZINE_FAILURE';
